export default __webpack_public_path__ + "static/media/thailand_icon.01a43796.svg";